export default "__VITE_ASSET__CctTLIox__"